import { apiClient } from './client';
import type { ClientsPageMeta } from './clients';

/**
 * Роль — /roles (см. докблок RoleController в Laravel, 1:1 старые Orchid
 * RoleListScreen/RoleEditScreen).
 */
export interface RoleRow {
  id: number;
  name: string;
  slug: string;
  usersCount: number;
  permissionsCount: number;
}

export interface RoleDetail {
  id: number;
  name: string;
  slug: string;
  /** Только включённые права. */
  permissions: string[];
}

/** Каталог прав — тот же реестр, что рисует галочки в старой админке. */
export interface PermissionGroup {
  title: string;
  permissions: { slug: string; description: string }[];
}

export interface FetchRolesParams {
  search?: string;
  page?: number;
}

export interface RolesPage {
  items: RoleRow[];
  meta: ClientsPageMeta;
}

export async function fetchRoles(params: FetchRolesParams = {}): Promise<RolesPage> {
  const { data } = await apiClient.get<RolesPage>('/roles', { params });
  return data;
}

export async function fetchPermissionCatalog(): Promise<PermissionGroup[]> {
  const { data } = await apiClient.get<{ groups: PermissionGroup[] }>('/roles/permissions');
  return data.groups;
}

export async function fetchRole(id: number): Promise<RoleDetail> {
  const { data } = await apiClient.get<RoleDetail>(`/roles/${id}`);
  return data;
}

export interface SaveRolePayload {
  name: string;
  slug: string;
  permissions: string[];
}

export async function createRole(payload: SaveRolePayload): Promise<RoleDetail> {
  const { data } = await apiClient.post<RoleDetail>('/roles', payload);
  return data;
}

export async function updateRole(id: number, payload: SaveRolePayload): Promise<RoleDetail> {
  const { data } = await apiClient.put<RoleDetail>(`/roles/${id}`, payload);
  return data;
}

export async function deleteRole(id: number): Promise<void> {
  await apiClient.delete(`/roles/${id}`);
}
